import { render } from "./CatRounded.vue?vue&type=template&id=3e9f732c"
import script from "./CatRounded.vue?vue&type=script&lang=js"
export * from "./CatRounded.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__